const MARKDOWN_NOISE: Array<[RegExp, string]> = [
  [/```[\s\S]*?(```|$)/g, ' '],
  [/!\[[^\]]*\]\([^)]*\)/g, ' '],
  [/\[([^\]]*)\]\([^)]*\)/g, '$1'],
  [/https?:\/\/\S+/g, ' '],
  [/<\/?[a-z][^>]*>/gi, ' '],
  [/^\s{0,3}(#{1,6}|>|[-*+]|\d+[.)])\s+/gm, ''],
  [/[`*_~]/g, ''],
]

/** Markdown reduced to its words: code, images, bare URLs and HTML dropped, link text kept. */
export const stripMarkdown = (text: string): string =>
  MARKDOWN_NOISE.reduce(
    (plain, [pattern, replacement]) => plain.replace(pattern, replacement),
    text,
  )
